/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum PorterDuffMode {
  UNAVAILABLE = 0,
  CLEAR = 1,
  SRC = 2,
  DST = 3,
  SRC_OVER = 4,
  DST_OVER = 5,
  SRC_IN = 6,
  DST_IN = 7,
  SRC_OUT = 8,
  DST_OUT = 9,
  SRC_ATOP = 10,
  DST_ATOP = 11,
  XOR = 12,
  DARKEN = 13,
  LIGHTEN = 14,
  MULTIPLY = 15,
  SCREEN = 16,
  ADD = 17,
  OVERLAY = 18,
}
